import React from "react";

import {
  Link,
  graphql,
  useStaticQuery,
} from "gatsby";

import {
  GatsbyImage,
  getImage,
} from "gatsby-plugin-image";

import "./Header.scss";

import SearchBar from "./SearchBar";
import LanguageSwitcher from "./LanguageSwitcher";
import MobileMenu from "./MobileMenu";



const Header: React.FC = () => {



  const data = useStaticQuery(graphql`

    query HeaderLogoQuery {

      logo:

      file(
        relativePath: {
          eq: "logo_sorrentoadvice.png"
        }
      ) {


        childImageSharp {


          gatsbyImageData(

            width: 220

            placeholder: BLURRED

            quality: 90


          )


        }


      }


    }

  `);




  const logoImage =
    getImage(
      data.logo.childImageSharp.gatsbyImageData
    );





  return (


    <header className="header">


      <div className="container">


        <div className="topRow">





          <Link

            to="/"

            className="logoLink"

          >


            {

              logoImage && (


                <GatsbyImage

                  image={logoImage}

                  alt="SorrentoAdvice"

                  className="logo"

                />


              )

            }


          </Link>





          <div className="searchWrapper">


            <SearchBar />


          </div>





          <div className="languageWrapper">


            <LanguageSwitcher />

            <MobileMenu />


          </div>




        </div>


      </div>


    </header>


  );

};


export default Header;